export type ValidityStateViolation = Exclude<keyof ValidityState, "valid">

// all keys of ValidityState except "valid"
export const validityStateViolations: ValidityStateViolation[] = [
  "badInput",
  "customError",
  "patternMismatch",
  "rangeOverflow",
  "rangeUnderflow",
  "stepMismatch",
  "tooLong",
  "tooShort",
  "typeMismatch",
  "valueMissing",
]
